<template>
<span :class="classes" v-if="showIn === true || showIn === msg.showIn">{{ msg.content }}</span>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Message',

    props: {
        showIn: {
            default: true,
            type: [String, Boolean]
        }
    },

    computed: {
        ...mapGetters('messageComponent', [
            'msg'
        ]),
        classes() {
            const classes = [
                'badge',
                'mb-2',
                'p-2',
                'w-100',
                'badge-'+this.msg.type
            ]

            return classes.join(' ')
        }
    }
}
</script>